import { Flex } from '@grupoboticario/flora-react';

import { BannerSkeleton } from '../Banner';
import { CardInfoSkeleton } from '../CardInfo';

export const CampaignContentSkeleton = () => {
  return (
    <Flex data-testid='skeleton-campaign-content' direction='column' gap='$20'>
      <BannerSkeleton />

      <CardInfoSkeleton />
    </Flex>
  );
};
